// SearchContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { encryptDecryptData } from "utils/helperFunction";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  
  // Initialize from localStorage
  const getStoredUser = () => {
    const stored = localStorage.getItem("user");
    if (stored) {
      try {
        return encryptDecryptData.decrypt(stored);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  const initialUser = getStoredUser();
  const [userAdminData, setUserAdminData] = useState(initialUser);
  const [token, setToken] = useState(initialUser?.token || null);

  useEffect(() => {
    if (!token || !userAdminData) {
      const storedUser = getStoredUser();
      if (storedUser) {
        if (storedUser.token) setToken(storedUser.token);
        setUserAdminData(storedUser);
      }
    }
  }, []);


  const updateSearchQuery = (query) => {
    setSearchQuery(query);
  };

  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        updateSearchQuery,
        loading,
        setLoading,
        userAdminData,
        setUserAdminData,
        token,
        setToken,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};
